import styles from './AccordionItem.module.css'
import classNames from 'classnames'
import { Heading } from '../../Heading/Heading'
import type { AccordionModifiers } from '../Accordion'

interface AccordionItemProps extends AccordionModifiers {
  title: string
  children: React.ReactNode
}

export const AccordionItem = ({ title, children, variant, isItalic, isLarge }: AccordionItemProps) => {
  const accordionItemClasses = classNames(styles.AccordionItem, {
    [styles['AccordionItem--secondary']]: variant === 'secondary',
    [styles['AccordionItem--is-italic']]: isItalic,
    [styles['AccordionItem--is-large']]: isLarge,
  })
  return (
    <details className={accordionItemClasses}>
      <summary className={styles.AccordionItem__summary}>
        <Heading tagSize={3} fontClass={variant === 'primary' ? 'sp' : 'h6'} noMarginBottom>
          {title}
        </Heading>
        <span className={styles.AccordionItem__icon} />
      </summary>
      <div className={styles.AccordionItem__content}>
        {typeof children === 'string' ? <div dangerouslySetInnerHTML={{ __html: children  }} /> : children}
      </div>
    </details>
  )
}
